import type { CoinbaseWalletParameters } from 'wagmi/connectors'

import { SITE_LOGO, SITE_NAME } from '@src/configs/metadata'

export const defaultCoinbaseConfig: CoinbaseWalletParameters = {
    appName: SITE_NAME,
    appLogoUrl: SITE_LOGO,
}
